import { ProgressReportPreviewInterface } from "@/src/models/IProgress";
import { Button, Flex, Table, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function ProgressReportCheck(){
    const { project_id } = useParams();
    const [submittable,setSubmitable] = useState(true);
    const [ProgressReportList,setProgresslist] = useState<ProgressReportPreviewInterface[]>([])
    const navigate = useNavigate();

    function getData(){
        axios.get(`${process.env.REACT_APP_BASE}/GetProgressList/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status==200){
                console.log(response.data)
                setProgresslist(response.data)
            }
        })
    } 

    async function getIfCompletionSubmitted(){
        await axios.get(`${process.env.REACT_APP_BASE}/GetLastReportID/${project_id}`).then(async response=>{
            if(response.status==200){
                console.log(response.data)
               
                if(response.data.IsCompletion=='TRUE'||response.data.ReportStatus=='บันทึกชั่วคราว'){
                    setSubmitable(false)
                }

            }
        })
  }

  function DeleteallData(project_id:any,userid:any){
    axios.delete(`${process.env.REACT_APP_BASE}/DeleteLastProject/${userid}/${project_id}`).then(
        response=>{if(response.status==200){
            window.location.reload()
        }}
    )
  }

    
    

    useEffect(()=>{
        getData();
        getIfCompletionSubmitted();
    },[]);
    return (
    <>
        <Flex justify='space-between'>
            <h1 className="text-3xl font-semibold leading-relaxed">ประวัติรายงานความก้าวหน้าโครงงานวิจัย</h1>
            {submittable&&<Button onClick={()=>{
                navigate(`/VRIIS/ProgressReport/${project_id}`);
            }}>ยื่นรายงานความคืบหน้า</Button>}
        </Flex>
        <hr/>
        <Table
            columns={[
                {
                    title:'รอบการยื่นครั้งที่',
                    dataIndex:'SentOrder',
                    width:'7vw'
                },{
                    title:'ชื่อโครงงานวิจัย',
                    dataIndex:'project_name_th',
                },{
                    title:'วันเวลาที่ยื่นรายงาน',
                    dataIndex:'SentBy',
                    render: (_, record) => (
                        <>{moment(record.SentBy).utc().format('DD/MM/YY HH:mm:ss')}</>
                      ),
                },{
                    title:'สถานะ',
                    dataIndex:'ReportStatus',
                    render: (ReportStatus: string) => {
                        let color = 'white';
                        if (ReportStatus === 'ยื่นความคืบหน้าโครงการ') {
                          color = 'geekblue';
                        } else if (ReportStatus === 'แก้ไข'||ReportStatus == 'บันทึกชั่วคราว'
                        ) {
                          color = 'yellow';
                        } else if (ReportStatus === 'ผ่าน'
                        ) {
                          color = 'green';
                        }
                         else  {
                          color = 'yellow';
                        } 
                        return <Tag color={color}>{ReportStatus}</Tag>;
                      },
                },{
                    dataIndex:'action',
                    render: (_, record) => (
                        <>
                            <Flex justify='center'>
                                <Button onClick={()=>navigate(`/VRIIS/ProgressReportEdit/${project_id}/${record.ProgressReportID}`)}>ดูข้อมูล</Button>
                            </Flex>
                            <br/>
                            <Flex justify='center'>
                            {record.ReportStatus=='บันทึกชั่วคราว'&&<>
                                <Button onClick={()=>DeleteallData(record.ProgressReportID,sessionStorage.getItem('user'))} danger>ลบข้อมูล</Button></>}
                            </Flex>
                           
                        </>
                      ),
                },
            ]}
            locale={{emptyText:'ยังไม่มีข้อมูลการยื่น'}}
            dataSource={ProgressReportList}/>
    </>)
}